import React from 'react';
import Link from 'app/components/presentation/link/Link';
import PageWrapper from 'app/components/materials/PageWrapper';
import { useI18n } from 'app/components/localization';
import ButtonClassNameA from 'app/components/presentation/buttons/ButtonClassNameA';
import TieupOwl403 from 'app/components/svgs/mascot/LockedDoor';
import { MaterialsRoute } from 'app/constants/Routes';
import OwlMessagePage from 'app/components/pages/OwlMessagePage';
import { useBrand } from '../OrganizationContext';

const LessonExpiredPage: React.FunctionComponent = () => {
  const { t } = useI18n();
  const brand = useBrand();

  return (
    <PageWrapper title={t('http-status-page.tieup.access-expired.header')}>
      <OwlMessagePage
        image={<TieupOwl403 width="100%" />}
        header={t('http-status-page.tieup.access-expired.header')}
        message={
          t('http-status-page.tieup.access-expired.message',
            { product: brand.name })
        }
        buttons={
          <ButtonClassNameA>{(buttonClassName) =>
            <Link
              to={MaterialsRoute.getPathname()}
              className={buttonClassName}
            >
              {t('http-status-page.tieup.access-expired.materials-btn')}
            </Link>
          }</ButtonClassNameA>
        }
      />
    </PageWrapper>
  );
};

export default LessonExpiredPage;
